/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './preview_application_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "Customer": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "applicationFlows": {
                        "type": ".squareup.sfs.external.models.PreviewApplicationFlow",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "primaryAccountId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "isLocked": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "archivedAt": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Customer) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc SFS Customer, with preview of ApplicationFlow.
 * --
 *
 * SOURCE Customer @ squareup/sfs/external/models/customer.proto at 11:1
 */
export const Customer = $root.lookupType('squareup.sfs.external.models.Customer');
fixType(Customer, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(Customer);